import { schema } from "normalizr";

const getriebeSchema = new schema.Entity("getriebe", {}, { idAttribute: "id" });

export { getriebeSchema };
